export interface HatColorOption {
  id: string;
  label: string;
  image: string;
  swatchColor: string;
  textColor: string;
}

export interface HatDetailRow {
  label: string;
  value: string;
}

export interface HatQualityItem {
  title: string;
  description: string;
  image: string;
}

export interface HatPerspectiveItem {
  title: string;
  image: string;
  className: string;
}

export const hatColorOptions: HatColorOption[] = [
  {
    id: "white",
    label: "White",
    image: "/image/apparel/hat/hat-white.webp",
    swatchColor: "#ffffff",
    textColor: "#231815",
  },
  {
    id: "black",
    label: "Black",
    image: "/image/apparel/hat/hat-black.webp",
    swatchColor: "#2f2f2f",
    textColor: "#ffffff",
  },
  {
    id: "ivory-white",
    label: "Ivory white",
    image: "/image/apparel/hat/hat-ivory-white.webp",
    swatchColor: "#ebe5d1",
    textColor: "#231815",
  },
  {
    id: "taro-purple",
    label: "Taro purple",
    image: "/image/apparel/hat/hat-taro-purple.webp",
    swatchColor: "#c8b4eb",
    textColor: "#ffffff",
  },
  {
    id: "royal-blue",
    label: "Royal blue",
    image: "/image/apparel/hat/hat-royal-blue.webp",
    swatchColor: "#003da8",
    textColor: "#ffffff",
  },
];

export const hatProductDetails: HatDetailRow[] = [
  { label: "Material composition", value: "100% Cotton" },
  { label: "Care instructions", value: "Machine Wash" },
  { label: "Origin", value: "Imported" },
  { label: "Closure type", value: "Buckle" },
];

export const hatMoreDetails: HatDetailRow[] = [
  { label: "Size", value: "56-60CM (Hat circumference)" },
  { label: "Date First Available", value: "30 March 2025" },
  { label: "Manufacturer", value: "Outdoor Hat-Dropship" },
  { label: "Marco number", value: "Hat001" },
  { label: "Department", value: "Unisex-adult" },
];

export const hatAboutItems = [
  "Front decorated with Red Marco matching embroidery",
  "Adjustable strap on the back with engraved silver metal rectangular buckle",
  "High quality cotton construction will wear well and only get better with age",
  "Great color choices. Grab your favorite or collect them all",
];

export const hatSizeOptions = ["56-60CM", "56-60CM"];

export const hatPromotionItems = [
  { status: "Redeemed", label: "Savings", description: "Buy 2, save 5%" },
  { status: "Redeemed", label: "Savings", description: "Buy 3, save 10%" },
];

export const hatPerspectiveItems: HatPerspectiveItem[] = [
  {
    title: "Front view",
    image: "/image/apparel/hat/perspective-front.webp",
    className: "front",
  },
  {
    title: "Vertical view",
    image: "/image/apparel/hat/perspective-vertical.webp",
    className: "vertical",
  },
  {
    title: "Side view",
    image: "/image/apparel/hat/perspective-side.webp",
    className: "side",
  },
];

export const hatQualityItems: HatQualityItem[] = [
  {
    title: "Sun hat brim",
    description: "The slightly curved brim modifies the face shape and blocks the sun",
    image: "/image/apparel/hat/quality-brim.webp",
  },
  {
    title: "Breathable air holes",
    description: "Breathable air holes, fine wiring, no stuffiness",
    image: "/image/apparel/hat/quality-air-holes.webp",
  },
  {
    title: "Fine routing",
    description: "The craftsman's patience is reflected in the details, and the fine lines are only for good quality",
    image: "/image/apparel/hat/quality-routing.webp",
  },
  {
    title: "Sweat-absorbent hat band",
    description: "Pure cotton hat band that absorbs sweat quickly",
    image: "/image/apparel/hat/quality-band.webp",
  },
  {
    title: "Adjust the hat stran",
    description: "Adjustable chin strap to meet the different wearing requirements of different head circumferences",
    image: "/image/apparel/hat/quality-strap.webp",
  },
  {
    title: "Front hat type",
    description: "Excellent hat version, quality, quality, quality",
    image: "/image/apparel/hat/quality-front-type.webp",
  },
];

export const getHatColorById = (id: string) => hatColorOptions.find((item) => item.id === id);

export const clampHatQuantity = (value: number | string) => {
  const numericValue = typeof value === "string" ? Number.parseInt(value, 10) : value;

  if (!Number.isFinite(numericValue)) {
    return 1;
  }

  return Math.min(9999, Math.max(1, Math.trunc(numericValue)));
};

export const updateHatQuantity = (currentValue: number | string, delta: number) =>
  clampHatQuantity(clampHatQuantity(currentValue) + delta);
